import { INSTITUTE_ID_ACADEMIC, INSTITUTE_ID_ACADEMIC_SPORT } from "utils/constants";

// What an organisation calls the people on its programme.
export const getLearnerTerms = (instituteId) => {
  if (instituteId === INSTITUTE_ID_ACADEMIC) {
    return { singular: "Learner", plural: "Learners" };
  }
  if (instituteId === INSTITUTE_ID_ACADEMIC_SPORT) {
    return { singular: "Player", plural: "Players" };
  }
  return { singular: "User", plural: "Users" };
};
